import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

type ContainerProps = {
  centered?: boolean
}

const titleContainerCenteredCss = ({ centered }: ContainerProps) =>
  centered &&
  css`
    justify-content: center;
  `

const shouldForwardProp = (prop: string) => !['centered'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: ${themeGet('space.3')}px;

  > svg {
    flex-shrink: 0;
    width: 35px;
    height: 35px;
    color: ${themeGet('colors.primary.main')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    flex-direction: row;
    gap: ${themeGet('space.3')}px;
    align-items: flex-start;

    > svg {
      margin-top: 4px;
    }
  }

  ${titleContainerCenteredCss}
`
